import useIsMobile from '@/hooks/use-is-mobile';
import { Box, Button, IconX } from '@cmpsr/components';
import BackButton from '@/components/back-button/back-button';
import NavigationBar from '@/components/layout/navigation-bar/navigation-bar';

type HeaderEditAnswerType = { onCloseClick: () => void; onBackClick?: () => void; showBackButton?: boolean };

export default function HeaderEditAnswer(props: HeaderEditAnswerType) {
  const isMobile = useIsMobile();
  const size = isMobile ? 's' : 'm';

  return (
    <NavigationBar
      leftContent={props.showBackButton && props.onBackClick ? <BackButton onClick={props.onBackClick} /> : null}
      rightContent={
        <Box textAlign="right">
          <Button
            py="4px"
            variant="ghost"
            sx={{
              ':hover': { backgroundColor: 'inherit', color: 'text-link-accent-hover' },
              ':active': { backgroundColor: 'inherit' },
              ':focus': { backgroundColor: 'inherit' },
            }}
            aria-label="Close modal"
            onClick={props.onCloseClick}
            size={size}
            color="text-light"
            trailingIcon={<IconX />}
            justifyContent="flex-end"
            width="auto"
          >
            {!isMobile && 'Close'}
          </Button>
        </Box>
      }
      beta
    />
  );
}
